import React, { useState } from 'react';
import { VideoProvider } from './components/VideoContext';
import { IntroAnimation } from './components/IntroAnimation';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { PortfolioSection } from './components/PortfolioSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { WhatsAppWidget } from './components/WhatsAppWidget';
import { GoogleAnalytics } from './components/GoogleAnalytics';
import { SEO } from './components/SEO';
import { ProductiesPage } from './pages/ProductiesPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { CookiePage } from './pages/CookiePage';
import { TermsPage } from './pages/TermsPage';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
export const App = () => {
  const [showContent, setShowContent] = useState(false);
  return <VideoProvider data-id="element-0">
      <Router data-id="element-1">
        <GoogleAnalytics data-id="element-2" />
        <SEO data-id="element-3" />
        <Routes data-id="element-4">
          <Route path="/" element={<>
                {!showContent && <IntroAnimation onComplete={() => setShowContent(true)} data-id="element-6" />}
                <div className={`min-h-screen bg-black text-white ${showContent ? 'opacity-100' : 'opacity-0'}`} data-id="element-7">
                  <Navbar data-id="element-8" />
                  <main data-id="element-9">
                    <HeroSection data-id="element-10" />
                    <AboutSection data-id="element-11" />
                    <PortfolioSection data-id="element-12" />
                    <ContactSection data-id="element-13" />
                  </main>
                  <Footer data-id="element-14" />
                  <WhatsAppWidget data-id="element-15" />
                </div>
              </>} data-id="element-5" />
          <Route path="/producties" element={<ProductiesPage data-id="element-17" />} data-id="element-16" />
          <Route path="/privacy" element={<PrivacyPage data-id="element-19" />} data-id="element-18" />
          <Route path="/cookies" element={<CookiePage data-id="element-21" />} data-id="element-20" />
          <Route path="/voorwaarden" element={<TermsPage data-id="element-23" />} data-id="element-22" />
        </Routes>
      </Router>
    </VideoProvider>;
};